<template>
  <div>
    <div class="white-section break-bottom">
      <div class="container text-center">
        <h2>
          Mitglieder online
        </h2>
        <hr />
        <el-carousel
          v-if="stats && stats.customers"
          :interval="4000"
          type="card"
          trigger="click"
        >
          <el-carousel-item
            v-for="(customer, key) in stats.customers"
            :key="key"
          >
            <img
              :src="`${customer.profilepicture}?height=150&width=150`"
              class="rounded-circle"
              style=""
              alt=""
            />
            <br />
            <div class="carousel-background">
              {{ customer.name }}
              <br />
              {{ customer.age }}
              <i class="fas fa-map-marker-alt"></i>
              {{ customer.city }}
              <br />
              <a class="btn btn-primary" :href="customer.profile">
                Chatten
              </a>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="stats-section">
      <div class="container">
        <div v-if="stats" class="col-lg-4 mx-auto white-background">
          <ul class="list-unstyled text-center stats-list">
            <li>
              <img
                height="64"
                :src="
                  `templates/startpage/${startPageLayout}/images/registerd_today.webp`
                "
                alt=""
              />
              {{ stats.registerd.today }} heute registriert
            </li>
            <li class="mt-2">
              <img
                height="64"
                :src="
                  `templates/startpage/${startPageLayout}/images/online_total.webp`
                "
                alt=""
              />
              {{ stats.online.total }} aktuell online
            </li>
            <br />
            <li>davon:</li>
            <li>
              <img
                height="64"
                :src="
                  `templates/startpage/${startPageLayout}/images/online_woman.webp`
                "
                alt=""
              />
              {{ stats.online.woman }}
              ({{ getPercentage(stats.online.woman, stats.online.total) }}%
              Weiblich)
            </li>
            <li class="mt-2">
              <img
                height="64"
                :src="
                  `templates/startpage/${startPageLayout}/images/online_man.webp`
                "
                alt=""
              />
              {{ stats.online.man }}
              ({{ getPercentage(stats.online.man, stats.online.total) }}%
              Männlich)
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, CarouselItem } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import moment from "moment";
export default {
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  data() {
    return {
      stats: null,
      slider_customer_amount: 12,
      slider_woman_percentage: 60,
      min_online: 5000,
      max_online: 25000,
      min_woman_percentage_online: 45,
      max_woman_percentage_online: 60,
      higlights: {
        "12": 1.5,
        "13": 2,
        "14": 2.5,
        "18": 2,
        "19": 2.5,
        "20": 2.8,
        "21": 3.5,
        "22": 2
      }
    };
  },
  created() {
    this.$http
      .get("/api/v1/site-information", {
        params: {
          customerAmount: this.slider_customer_amount,
          womanPercentage: this.slider_woman_percentage
        }
      })
      .then(response => {
        this.stats = response.data;

        let month = moment().format("D");
        let hour = moment().format("k");
        let minutes = moment().diff(moment().startOf("day"), "minutes");
        this.stats.registerd.today =
          parseInt(month) + parseInt(hour) + parseInt(minutes);

        let online_total =
          Math.random() * (this.max_online - this.min_online) + this.min_online;
        if (this.higlights[hour] !== undefined) {
          online_total = online_total * this.higlights[hour];
        }
        this.stats.online.total = Math.round(online_total);

        let woman_percentage_online = Math.round(
          Math.random() *
            (this.max_woman_percentage_online -
              this.min_woman_percentage_online) +
            this.min_woman_percentage_online
        );

        let man_percentage_online = 100 - woman_percentage_online;

        this.stats.online.woman = this.getAmount(
          woman_percentage_online,
          this.stats.online.total
        );
        this.stats.online.man = this.getAmount(
          man_percentage_online,
          this.stats.online.total
        );
      });
  },
  computed: {
    startPageLayout() {
      return Laravel.startPageLayout;
    }
  },
  methods: {
    getPercentage(amount, total) {
      return total ? Math.round((amount / total) * 100) : 0;
    },
    getAmount(percentage, total) {
      return total ? Math.round((total / 100) * percentage) : 0;
    }
  }
};
</script>
